export default __webpack_public_path__ + "static/media/terra.8b135c5c.png";